import { Injectable } from '@angular/core';
import { TileAnalysisGraphComponent } from '../../../components/tile/tile-analysis-graph/tile-analysis-graph';
import type { CustomTileModel } from '../../../interfaces/Tile.interface';
import type { CustomTileProvider } from './custom-tile.provider';

@Injectable({
    providedIn: 'root'
})
export class TileAnalysisGraphProvider implements CustomTileProvider {
    fillTileDescription(): CustomTileModel {
        throw Error('Not implemented');
    }

    getTileComponent() {
        return TileAnalysisGraphComponent;
    }
}
